import { Create, SimpleForm, TextInput, useRedirect, useGetOne, SelectInput, Edit } from 'react-admin';
import { useState } from 'react';
import { useParams } from 'react-router-dom';

export const ApiEdit = () => {

        return (
            <Edit title='Edit Api'>
                    <SimpleForm >
                    <TextInput label="Api Title" source="title" fullWidth />
                    <TextInput label="Endpoint" source="url" fullWidth />
                    <SelectInput fullWidth label="Interval Time" source="interval_time" choices={[
                        { id: 5, name: '5 Min' },
                        { id: 10, name: '10 Min' },
                        { id: 15, name: '15 Min' },
                        { id: 30, name: '30 Min' },
                        { id: 60, name: '1 Hr' },
                        { id: 120, name: '2 Hr' },
                        { id: 180, name: '3 Hr' },
                        { id: 360, name: '6 Hr' },
                        { id: 720, name: '12 Hr' },
                        { id: 1440, name: '1 Day' },
                    ]} />
                    <SelectInput fullWidth label="Status" source="status" choices={[
                        { id: '0', name: 'Inactive' },
                        { id: '1', name: 'Active' },
                    ]} />

                </SimpleForm>
            </Edit>
    );

}